import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";
const { Item } = Form;

export const HeaderInOperationContainer = styled.div`
  margin-top: 5px;
  margin-bottom: 37px;
`;

export const HeaderAwaitingOperationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  margin-top: 5px;
  margin-bottom: 37px;
`;

export const SearchFieldContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: end;
`;

export const SearchContainer = styled.div`
  display: grid;
  grid-template-columns: 0.6fr 1fr;
  grid-column-gap: 16px;
  align-items: end;

  .ant-select-selection-item {
    margin: auto;
  }
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    height: ${(props) => props.theme["@height-input-lg"]};
    &:hover {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-form-item {
    margin: auto;
    height: ${(props) => props.theme["@height-input-lg"]};
  }
`;

export const Title: React.CSSProperties = {
  margin: "9px 0",
  fontWeight: theme["@bold-font-weight"],
  fontSize: "20px",
  fontFamily: theme["@font-family"],
};

export const Description: React.CSSProperties = {
  margin: "9px 0",
  fontWeight: theme["@normal-font-weight"],
  fontSize: "14px",
  fontFamily: theme["@font-family"],
};

export const ShippingTruckIcon: CSSProperties = {
  marginRight: "10px",
  alignItems: "center",
};

export const FormItem = styled(Item)`
  .ant-form-item-control-input-content > input {
    margin-left: 0;
    border: 1px solid ${(props) => props.theme.colors.manatee};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .ant-form-item-label > label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    pointer-events: none !important;
  }

  .ant-form-item-label {
    text-align: start;
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: 300;
    padding: 3px 0;
    z-index: 1;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid ${(props) => props.theme.colors.manatee};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    }
  }

  .ant-input-disabled {
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      cursor: default;
      > input {
        background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
        border: none !important;
      }
    }
  }
  .ant-form-item-control-input-content > .ant-input.ant-input-status-error {
    border: 1.6px solid ${(props) => props.theme["@danger-color"]} !important;
    background-color: ${(props) => props.theme["@danger-background"]};
    :hover {
      border-color: ${(props) => props.theme["@danger-color"]};
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
  }
`;

export const VehicleActionContainer = styled.div``;

export const RadioContainer = styled.div`
  height: 50px;
  margin: 10px -8px 0 -8px;
  .ant-radio-wrapper.ant-radio-wrapper-checked.radioButton {
    border: 2px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    border-radius: 4px;
  }
  .ant-radio-wrapper.radioButton {
    background-color: ${(props) => props.theme["@opacity-color-default-background"]};
    border-radius: 4px;
    border: 1.6px solid ${(props) => props.theme["@box-shadow"]} !important;
  }
  .ant-radio.ant-radio-checked {
    background-color: ${(props) => props.theme["@opacity-color-default-background"]} !important;
    margin-left: 8px;
    margin-top: -5px;
  }
  .ant-radio {
    margin-left: 8px;
    margin-top: -5px;
  }
  .radioButton {
    margin-left: 8px;
    align-items: center;
  }
`;

export const VehiclePlate = styled.span`
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
`;

export const DescriptionVehicleAction = styled.h3`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  margin: 0;
`;

export const DriverWarningDescription = styled.h3`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  margin-top: 20px;
`;

export const DescriptionVehicleActionContainer = styled.div`
  text-align: center;
  margin-top: 45px;
`;

export const RadioGroup: CSSProperties = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  height: theme["@height-input-lg"],
};

export const RadioOnlyOption: CSSProperties = {
  display: "grid",
  gridTemplateColumns: "1fr",
  height: theme["@height-input-lg"],
};

export const DockDescriptionField: CSSProperties = {
  width: "100%",
  height: theme["@height-input-lg"],
  borderRadius: "4px",
};

export const FormLayout: CSSProperties = {
  height: "100%",
};

export const LayoutContentInOperation = styled.div`
  padding: 30px 24px;
  background-color: ${(props) => props.theme["@default-background"]};
  border-radius: 6px;
  box-shadow: 0 1px 5px ${(props) => props.theme["@box-shadow"]};
  margin-bottom: 30px;
  display: flex;
`;

export const LayoutWithoutContentInOperation = styled.div`
  padding: 30px 24px;
  background-color: ${(props) => props.theme["@default-background"]};
  border-radius: 6px;
  box-shadow: 0 1px 5px ${(props) => props.theme["@box-shadow"]};
  margin-bottom: 30px;
  height: 215px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    font-size: 32px;
    color: ${(props) => props.theme.colors.manatee};
  }
`;

export const SelectField: CSSProperties = {
  color: theme.colors.text,
  fontFamily: theme["@font-family"],
  height: theme["@@height-input-lg"],
};

export const CloseDrawer = styled.span`
  .closeIcon > svg {
    color: ${(props) => props.theme["@input-border-color"]} !important;
    cursor: pointer !important;
    :hover {
      color: ${(props) => props.theme.colors.text} !important;
    }
  }
`;
